import {Routes, RouterModule} from '@angular/router';
import {WhatIsLogComponent} from './what-is-log.component';

const routes: Routes = [
  {
    path: 'what_is_log',
    component : WhatIsLogComponent
  }];

export const routing = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/what-is-log/what-is-log.routing.ts